
const BASE = {
	API_DEV: {
		apiLink: 'https://www.fxinpz.com/manager-api',
		// apiLink: 'http://192.168.0.59:8803',
		common: 'https://www.fxinpz.com/common-api',
		// common: 'http://192.168.0.59:8803',
	},
	API_PRO: {
		apiLink: 'https://www.fxinpz.com/manager-api',
		common: 'https://www.fxinpz.com/common-api',
	},
};


module.exports = {
	fileServer: (process.env.NODE_ENV === 'development') ? BASE.API_DEV.fileServer : BASE.API_PRO.fileServer,
	apiLink: (process.env.NODE_ENV === 'development') ? BASE.API_DEV.apiLink : BASE.API_PRO.apiLink,
	common: (process.env.NODE_ENV === 'development') ? BASE.API_DEV.common : BASE.API_PRO.common,
	loginLink: (process.env.NODE_ENV === 'development') ? BASE.API_DEV.loginLink : BASE.API_PRO.loginLink
};
